<template>
  <edit-modal
    :is-show-dialog="isShowDialog"
    action-label="Сохранить"
    :title="dialogTitle"
    @on-close="onClose"
    @on-action="onAction"
  >
    <v-overlay
      :absolute="true"
      :value="isLoading"
    >
      <v-progress-circular indeterminate size="24"></v-progress-circular>
    </v-overlay>
    <v-form
      ref="form"
      autocomplete="off"
      method="post"
      action=""
    >
      <v-container>
        <v-row
          v-model="valid"
          :lazy-validation="true"
        >
          <v-col
            cols="12"
            md="4"
          >
            <v-text-field
              v-model="editableObject.amount"
              type="number"
              step="0.01"
              min="0.01"
              :rules="[rules.required]"
              :label="$t('warehouse.quantity')"
              required
              autocomplete="off"
              :error-messages="(errors && errors.amount)?errors.amount:null"
              @input="removeError('amount')"
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            md="4"
          >
            <v-text-field
              v-model="editableObject.price"
              type="number"
              step="0.01"
              min="0.01"
              :rules="[rules.min(0), rules.max(200)]"
              :label="$t('warehouse.price')"
              prepend-icon="mdi-cash-100"
              required
              autocomplete="off"
              :error-messages="(errors && errors.price)?errors.price:null"
              @input="removeError('price')"
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            md="4"
          >
            <v-text-field
              v-model="editableObject.note"
              :counter="200"
              :rules="[rules.max(200)]"
              prepend-icon="mdi-tooltip-text-outline"
              :label="lang($store, 'sap/listings.global.filter.hints.note')"
              autocomplete="off"
              :error-messages="(errors && errors.note)?errors.note:null"
              @input="removeError('note')"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </edit-modal>
</template>

<script>
/* utils */
import StockItemProxy from '@/proxies/Stock/StockItemProxy';
import { deepMerge, cloneObj, prepareValidationMessages } from '../../utils';
/* mixins */
import editModalMixin from '../../mixins/editModalMixin';
import validationMixin from '../../mixins/validationMixin';
/* components */
import EditModal from './EditModal.vue';


export default {
  name: 'EditModalStockIncome',
  mixins: [editModalMixin, validationMixin],
  components: {
    EditModal,
  },
  props: {
    stockItem: {
      type: Object,
      default: () => {
      },
    },
    item: {
      type: Object,
      default: () => {
      },
    },
  },
  data() {
    return {
      isLoading: false,
      /* Data */
      initialEditableObject: {
        amount: 0,
        price: 0,
        note: '',
      },
      editableObject: {},
      errors: {},
    };
  },
  mounted() {
    this.initEditableObject();
  },
  computed: {
    isCreation() {
      return !(this.item.amount);
    },
    dialogTitle() {
      return '';
    },
  },
  watch: {
    isShowDialog(newVal) {
      if (newVal) {
        this.initEditableObject();
        this.resetValidation();
      }
    },
  },
  methods: {
    initEditableObject() {
      this.editableObject = deepMerge(cloneObj(this.initialEditableObject), this.item);
    },
    resetValidation() {
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    onAction() {
      if (this.$refs.form.validate()) {
        const data = {
          note: this.editableObject.note,
          price: (this.editableObject.price * 100).toFixed(0),
          amount: (this.editableObject.amount * 100).toFixed(0),
        };
        this.isLoading = true;
        new StockItemProxy()
          .amountAdd(this.stockItem.id, data)
          .then((response) => {
            console.log(response);
            this.$emit('on-action', {
              item: this.stockItem,
              itemEvent: this.editableObject,
            });
            this.errors = {};
          })
          .catch((error) => {
            this.errors = prepareValidationMessages(error.data.data);
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
  },
};
</script>

<style lang="sass" scoped>

</style>
